<template>
  <div>
    <template v-if="disabled">
      <slot></slot>
    </template>
    <template v-else>
      <div class="sidebar-page">
        <section class="sidebar-layout">

          <b-sidebar
              position="static"
              :mobile="'reduce'"
              :reduce="reduce"
              open
              :fullheight="true"
              style="min-height: calc(100vh - 80px)"
          >
            <div class="p-1">

              <MenuRecursive
                  v-model="activePath"
                  :items="items"
                  :allLevelsConfig="allLevelsConfig"
              />

              <b-menu class="is-custom-mobile">
                <b-menu-list label="">
                  <b-menu-item @click="toggleReduce">
                    <template #label="">
                      <div style="display:inline-block">
                        <b-icon
                            :icon="reduce ? 'arrow-right-2' : 'arrow-left-2'"
                            class="has-text-black is-pulled-left mr-1"
                        />
                        <span>Collapse</span>
                      </div>
                    </template>
                  </b-menu-item>
                </b-menu-list>
              </b-menu>
            </div>
          </b-sidebar>

          <div class="p-4" style="width:100%;overflow: hidden">
            <slot></slot>
          </div>

        </section>
      </div>
    </template>
  </div>
</template>

<script>
import MenuRecursive from "@/components/global/MenuRecursive.vue"
import VueCookies from 'vue-cookies';
let sisTenantId = VueCookies.get('sisTenantId')
export default {
  name: "sitewideSideMenu",
  components: {
    MenuRecursive
  },
  props:{
    disabled: {
      type: Boolean,
      default() {
        return false
      }
    },
  },
  data() {

    const items = [
      {
        id: "/dashboard",
        name: 'Dashboard',
        icon: 'element',
        iconOpen: 'element',
        tooltip: 'element',
      },
      {
        id: "/courses",
        name: 'Courses',
        icon: 'book',
        iconOpen: 'book',
      },
      {
        id: "/forum",
        name: 'Forums',
        icon: 'profile-2user',
        iconOpen: 'profile-2user',
      },
      {
        id: "/notes/course-modules",
        name: 'Notes',
        icon: 'note',
        iconOpen: 'note',
      },

      {
        id: "/workspace",
        name: 'Workspace',
        icon: 'book',
        iconOpen: 'book',
      },
      {
        id: "/lessons",
        name: 'Lessons',
        icon: 'table',
        iconOpen: 'table',
      }
    ]

    if ((VueCookies.get('lmsTenantId') === '44')) {
      items.push({
        id: "/book",
        name: 'Book a Tutor',
        icon: 'phone',
        iconOpen: 'phone',
      });
    }

    return {
      reduce: true,
      items: items,
      allLevelsConfig: [
        {
          labelField: 'name',
          heading: '',
          iconsAreStatic: false,
          idField: 'id',
          hasTooltip: true,
          icon: {
            isDynamic: true,
            closedField: 'icon',
            openField: 'iconOpen',
          },
        },
      ]
    };
  },
  computed: {
    activePath: {
      set(newVal) {
        if (this.activePath !== newVal) {
          this.$router.push(newVal)
        }
      },
      get() {
        return this.$route.path;
      },
    },
  },
  methods: {
    toggleReduce() {
      this.reduce = !this.reduce
    }
  },
};
</script>

<style lang="scss">
//start of code from https://buefy.org/documentation/sidebar/
.p-1 {
  padding: 1em;
}

.sidebar-page {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  .sidebar-layout {
    display: flex;
    flex-direction: row;
    min-height: 100%;
  }
}

@media screen and (max-width: 1023px) {
  .b-sidebar {
    .sidebar-content {
      &.is-mini-mobile {
        &:not(.is-mini-expand),
        &.is-mini-expand:not(:hover):not(.is-mini-delayed) {
          .menu-list {
            li {
              a {
                span:nth-child(2) {
                  display: none;
                }
              }

              ul {
                padding-left: 0;

                li {
                  a {
                    display: inline-block;
                  }
                }
              }
            }
          }

          .menu-label:not(:last-child) {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1024px) {
  .b-sidebar {
    .sidebar-content {
      &.is-mini {
        &:not(.is-mini-expand),
        &.is-mini-expand:not(:hover):not(.is-mini-delayed) {
          .menu-list {
            li {
              a {
                span:nth-child(2) {
                  display: none;
                }
              }

              ul {
                padding-left: 0;

                li {
                  a {
                    display: inline-block;
                  }
                }
              }
            }
          }

          .menu-label:not(:last-child) {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}

.is-mini-expand {
  .menu-list a {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}


//end of code from https://buefy.org/documentation/sidebar/


.b-sidebar {
  .is-fullheight {
    overflow: visible !important;
  }

  .sidebar-content {
    &.is-mini {
      &:not(.is-mini-expand),
      &.is-mini-expand:not(:hover):not(.is-mini-delayed) {
        .menu-list {
          li {
            a {
              text-align: center;
            }
          }
        }
      }
    }
  }
}


</style>
